export default __webpack_public_path__ + "static/media/6.f696a838.jpg";